import { useEffect, useState } from "react";
import { apiClient } from "@/lib/auth";
import { TrendingUp, PenSquare, Calendar, Eye } from "lucide-react";

export default function WeeklyDigest() {
  const [d, setD] = useState(null);
  useEffect(() => { apiClient.get("/digest/weekly").then(r => setD(r.data)).catch(()=>{}); }, []);
  if (!d) return null;

  const day = new Date().toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long" });
  const items = [
    { icon: TrendingUp, label: "Visibilité", value: `+${d.score_delta}`, sub: `${d.score_now}/100`, accent: "text-emerald-500 bg-emerald-500/10" },
    { icon: PenSquare, label: "Contenus rédigés", value: d.content_published, sub: "cette semaine", accent: "text-primary bg-primary/10" },
    { icon: Calendar, label: "Publications planifiées", value: d.publications_planned, sub: "à venir", accent: "text-violet-500 bg-violet-500/10" },
    { icon: Eye, label: "Portée estimée", value: d.estimated_reach.toLocaleString("fr-FR"), sub: "vues potentielles", accent: "text-amber-500 bg-amber-500/10" },
  ];

  return (
    <div className="border border-border rounded-2xl p-6 bg-card" data-testid="weekly-digest">
      <div className="flex items-center justify-between mb-5">
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-muted-foreground">Votre semaine en chiffres</p>
          <h3 className="font-bold text-lg mt-1 font-display tracking-tight capitalize">{day}</h3>
        </div>
        <span className="text-xs px-2.5 py-1 rounded-full bg-primary/10 text-primary font-bold uppercase tracking-wider">{d.period}</span>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {items.map((it, i) => (
          <div key={i} className="border border-border rounded-xl p-4">
            <div className={`h-7 w-7 rounded-md flex items-center justify-center mb-2 ${it.accent}`}>
              <it.icon className="h-3.5 w-3.5" />
            </div>
            <div className="text-2xl font-black font-display tabular-nums">{it.value}</div>
            <p className="text-[10px] uppercase tracking-wider font-bold text-muted-foreground mt-0.5">{it.label}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{it.sub}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
